import React, { useState, useEffect } from "react";
import { bookingService } from "../../services/api";
import "./BookingsTab.css";

const BookingsTab = ({ onSuccess, onError }) => {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchBookings = async () => {
    try {
      setLoading(true);
      const data = await bookingService.getBookings();
      setBookings(data);
    } catch (err) {
      onError("Không thể tải danh sách yêu cầu tư vấn.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBookings();
  }, []);

  const handleStatusChange = async (id, currentStatus) => {
    const newStatus = currentStatus === "pending" ? "processed" : "pending";
    try {
      // In a real app, you'd add an updateBookingStatus to bookingService.
      // But we can just use fetch directly if it's missing.
      const res = await fetch(`${process.env.REACT_APP_API_URL || (window.location.hostname !== "localhost" ? "/api" : "http://localhost:5000/api")}/bookings/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ status: newStatus })
      });
      if (res.ok) {
        onSuccess("Đã cập nhật trạng thái thành công");
        fetchBookings();
      } else {
        onError("Lỗi cập nhật trạng thái");
      }
    } catch (err) {
      onError("Lỗi kết nối");
    }
  };

  const formatDate = (dateStr) => {
    return new Date(dateStr).toLocaleString("vi-VN");
  };

  if (loading && bookings.length === 0) {
    return <div className="tab-content">Đang tải dữ liệu...</div>;
  }

  return (
    <div className="tab-content">
      <div className="bookings-header">
        <h2>Quản Lý Yêu Cầu Tư Vấn</h2>
        <button className="btn btn-outline" onClick={fetchBookings}>🔄 Làm mới</button>
      </div>

      <div className="table-responsive">
        <table className="admin-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Ngày gửi</th>
              <th>Thông tin liên hệ</th>
              <th>Nội dung tư vấn</th>
              <th>Trạng thái</th>
              <th>Thao tác</th>
            </tr>
          </thead>
          <tbody>
            {bookings.length === 0 ? (
              <tr>
                <td colSpan="6" style={{ textAlign: "center", padding: "30px" }}>Chưa có yêu cầu tư vấn nào.</td>
              </tr>
            ) : (
              bookings.map((b) => (
                <tr key={b.booking_id}>
                  <td>#{b.booking_id}</td>
                  <td>{formatDate(b.created_at)}</td>
                  <td><strong>{b.contact_info}</strong></td>
                  <td style={{ maxWidth: "300px", whiteSpace: "normal" }}>{b.notes}</td>
                  <td>
                    <span className={`status-badge ${b.status}`}>
                      {b.status === "pending" ? "Chờ xử lý" : "Đã tư vấn"}
                    </span>
                  </td>
                  <td>
                    <button 
                      className={`btn-small ${b.status === "pending" ? "btn-primary" : "btn-outline"}`}
                      onClick={() => handleStatusChange(b.booking_id, b.status)}
                    >
                      {b.status === "pending" ? "Đánh dấu đã xử lý" : "Hoàn tác"}
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BookingsTab;
